import { HANDLING_NOT_ALLOWED_ERROR_RESPONSES } from 'redux/modules/error-handler/constants';

const isHandling400Error = (errorDetails) => {
  const non_field_errors = (errorDetails || {}).non_field_errors || [];
  return HANDLING_NOT_ALLOWED_ERROR_RESPONSES.some((r) => non_field_errors.includes(r));
};

export { isHandling400Error };
